export const SET_STREAM = 'STREAM::SET'
export const SET_VIDEO_CONTROLLED = 'VIDEO::SET::CONTROLLED'
export const SET_VIDEO_DISPLAY = 'VIDEO::SET::DISPLAY'
export const SET_CAPTIONS_DISPLAY = 'CAPTIONS::SET::DISPLAY'
export const SET_AUDIO_SETTING = 'AUDIO::SET::SETTING'
export const GOT_CAPTIONS = 'CAPTIONS::GOT'
export const GET_SERVER_TIME = 'SERVER::TIME::GET'
export const SET_SERVER_TIME = 'SERVER::SET::TIME'
export const SET_PACKET_LOST = 'PACKET::SET::LOST'
export const SHOW_SET_VIDEO_DISPLAY = 'SHOW::VIDEO::SET'

export const SET_NUM_VIEWERS = 'VIEWERS::SET::NUMBER'
export const SET_FRAME_RATE = 'FRAME::RATE::SET'
export const SET_TOTAL_PACKETS_VIDEO = 'VIDEO::PACKETS::SET'
export const SET_TOTAL_PACKETS_AUDIO = 'AUDIO::PACKETS::SET'
export const SET_BITRATE_SENT = 'BITRATE::SET'



// WEBPACK FOOTER //
// ./src/types/actions/stream.js